import * as deesWccTools from '@design.estate/dees-wcctools';
import * as elements from '../ts_web/elements/index.js';
import * as pages from '../ts_web/pages/index.js';

deesWccTools.setupWccTools({
  sections: [
    {
      name: 'Pages',
      type: 'pages',
      items: pages,
    },
    {
      name: 'Elements',
      type: 'elements',
      items: elements,
      filter: (name) => !name.toLowerCase().includes('demoview'),
      sort: ([a], [b]) => a.localeCompare(b),
    },
  ],
});
